export default "@import url(\"/frontend/public/css/app.css\");"